import Modals, { useModals } from 'components/shared/Modals'
import React from 'react'
import triggerGAEvent from 'utils/triggerGAEvent'
import TidyCallModal from './TidyCalModal'

interface ScheduleCallButtonProps {
	title?: string
	className?: string
	gaEvent?: string
	externalCallUrl?: string
}

const ScheduleCallButton = ({
	title,
	className,
	gaEvent,
	externalCallUrl = '',
}: ScheduleCallButtonProps) => {
	const modals = useModals()
	const dataPath =
		externalCallUrl && externalCallUrl.includes('https://tidycal.com/')
			? externalCallUrl.replace('https://tidycal.com/', '')
			: null

	const openCallAction = (event) => {
		event.preventDefault()
		if (!externalCallUrl || dataPath) {
			openTidyCalModal()
		} else {
			if (isEmail(externalCallUrl)) {
				externalCallUrl = `mailto:${externalCallUrl}`
			}

			const target = externalCallUrl.startsWith('mailto:') ? '_self' : '_blank'
			window.open(externalCallUrl, target)
		}
	}
	// add function to detect if string is e-mail adres

	const isEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
		return emailRegex.test(email)
	}

	const openTidyCalModal = () => {
		if (typeof window !== 'undefined') {
			modals.open('TidyCallModal')
		}
	}

	return (
		<>
			<button
				className={
					className ??
					'bg-gray-900 hover:bg-black text-white duration-300 transition-colors mb-4'
				}
				onClick={($event) => {
					triggerGAEvent.call(this, {
						page: window.location.href,
						event: gaEvent ?? 'scheduleACall',
					})
					openCallAction($event)
				}}
			>
				{title || 'Schedule a call'}
			</button>
			<Modals handler={modals}>
				<TidyCallModal dataPath={dataPath} />
			</Modals>
		</>
	)
}

export default ScheduleCallButton
